import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_XS } from "@src/common/styles/const";
import { media } from "@src/common/styles/mixins";

export const SmallTileWrapper = styled.div<{
  $hasFullBackground?: boolean;
  $isActive: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ $hasFullBackground }) =>
    $hasFullBackground ? colors.white : colors.background};
  border-radius: 12px;
  padding: ${DEFAULT_MARGIN_XS}px;
  width: 104px;
  height: 140px;
  border: 2px solid ${(p) => (p.$isActive ? colors.darkBlue : "transparent")};
  cursor: pointer;

  ${media.down("TABLET")`
    background-color: ${colors.white};
  `}
`;

export const SmallTileImgWrapper = styled.div`
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
`;

export const SmallTileImg = styled.img`
  object-fit: contain;
  width: 100%;
`;

export const SmallTileName = styled.h3`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2em;
  text-align: center;
  margin: 0;
  height: 34px;
  color: ${colors.gray3};
`;
